import { Link } from "react-router-dom";
import { ButtonComp } from "./HeroPage";

function LandingFooter() {
  const routes = [
    { label: "Home", href: "/home" },
    { label: "About Us", href: "/about-us" },
    { label: "Our Services", href: "/our-services" },
    { label: "Contact Us", href: "/contact-us" },
  ];

  const RouteComp = ({ route }: any) => {
    return (
      <Link to="/">
        <h6 className="text-[#7D819A] font-stolzl">{route.label}</h6>
      </Link>
    );
  };

  return (
    <div className="bg-[#1B1E2FCC] pt-2 space-y-12">
      <div className="max-w-7xl space-y-6 mx-auto mt-20">
        <h2 className="text-4xl font-stolzl-r text-center text-white">
          Become a Partner in Innovation
        </h2>
        <p className="font-stolzl text-gray-400 text-center leading-7">
          Are you ready to take your business to the next level? Connect with a
          dedicated Partner Manager at AdaptClouds today, and discover a world of
          <br /> exclusive benefits, dynamic incentives, and collaborative
          growth opportunities that await you as our partner.
        </p>
      </div>
      <div className="text-center">
        <ButtonComp> Enroll as a Partner</ButtonComp>
      </div>
      <div className="flex  justify-between items-center my-4 max-w-7xl mx-auto">
        <div>
          <img
            width={"75"}
            height={"75"}
            src="logo.webp"
            alt=""
          />
        </div>
        <div className="flex gap-14 ">
          {" "}
          {routes.map((route) => (
            <RouteComp route={route} />
          ))}
        </div>
      </div>

      <div className="max-w-7xl p-4 mx-auto text-[#7D819A] flex justify-between text-center items-center">
        <p className="">© 2024 All Rights Reserved.</p>

        <div className="flex items-center space-x-4">
          <h4>Follow Us</h4>
          <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_3660_24446)">
              <path
                d="M38.81 19.78C38.81 9.27002 30.29 0.75 19.78 0.75C9.27002 0.75 0.75 9.27002 0.75 19.78C0.75 30.29 9.27002 38.81 19.78 38.81C30.29 38.81 38.81 30.29 38.81 19.78Z"
                stroke="#7D819A"
                strokeWidth="1.5"
                strokeMiterlimit="10"
              />
              <path
                d="M16.88 31.2798H21.51V19.6798H24.74L25.08 15.7998H21.5V13.5898C21.5 12.6698 21.68 12.3098 22.57 12.3098H25.08V8.27979H21.87C18.42 8.27979 16.87 9.79979 16.87 12.6998V15.7998H14.46V19.7298H16.87V31.2798H16.88Z"
                fill="#7D819A"
              />
            </g>
            <defs>
              <clipPath id="clip0_3660_24446">
                <rect width="39.56" height="39.56" fill="white" />
              </clipPath>
            </defs>
          </svg>

          <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_3660_24442)">
              <path
                d="M19.78 38.81C9.27 38.81 0.75 30.29 0.75 19.78C0.75 9.27 9.27 0.75 19.78 0.75C30.29 0.75 38.81 9.27 38.81 19.78C38.81 30.29 30.29 38.81 19.78 38.81Z"
                stroke="#7D819A"
                strokeWidth="1.5"
                strokeMiterlimit="10"
              />
              <path
                d="M9.64014 26.15C11.4801 27.33 13.6701 28.02 16.0201 28.02C23.7401 28.02 28.1101 21.5 27.8501 15.64C28.6601 15.05 29.3701 14.32 29.9301 13.49C29.1801 13.82 28.3801 14.04 27.5401 14.14C28.4001 13.63 29.0601 12.81 29.3701 11.84C28.5701 12.32 27.6801 12.66 26.7301 12.85C25.9701 12.04 24.8901 11.54 23.6901 11.54C21.0001 11.54 19.0301 14.05 19.6401 16.65C16.1801 16.48 13.1201 14.82 11.0601 12.3C9.97014 14.17 10.4901 16.62 12.3501 17.86C11.6701 17.84 11.0301 17.65 10.4601 17.34C10.4201 19.27 11.8001 21.07 13.8001 21.47C13.2101 21.63 12.5701 21.67 11.9201 21.54C12.4501 23.19 13.9901 24.4 15.8101 24.43C14.0601 25.8 11.8601 26.41 9.65014 26.15H9.64014Z"
                fill="#7D819A"
              />
            </g>
            <defs>
              <clipPath id="clip0_3660_24442">
                <rect width="39.56" height="39.56" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_3660_24436)">
              <path
                d="M19.78 38.81C9.27 38.81 0.75 30.29 0.75 19.78C0.75 9.27 9.27 0.75 19.78 0.75C30.29 0.75 38.81 9.27 38.81 19.78C38.81 30.29 30.29 38.81 19.78 38.81Z"
                stroke="#7D819A"
                strokeWidth="1.5"
                strokeMiterlimit="10"
              />
              <path
                d="M19.7799 11.2301C22.5699 11.2301 22.8999 11.2401 23.9999 11.2901C25.0199 11.3401 25.5699 11.5101 25.9399 11.6501C26.4299 11.8401 26.7699 12.0701 27.1399 12.4301C27.5099 12.8001 27.7299 13.1401 27.9199 13.6301C28.0599 14.0001 28.2299 14.5501 28.2799 15.5701C28.3299 16.6701 28.3399 17.0001 28.3399 19.7901C28.3399 22.5801 28.3299 22.9101 28.2799 24.0101C28.2299 25.0301 28.0599 25.5801 27.9199 25.9501C27.7299 26.4401 27.4999 26.7801 27.1399 27.1501C26.7799 27.5101 26.4299 27.7401 25.9399 27.9301C25.5699 28.0701 25.0199 28.2401 23.9999 28.2901C22.8999 28.3401 22.5699 28.3501 19.7799 28.3501C16.9899 28.3501 16.6599 28.3401 15.5599 28.2901C14.5399 28.2401 13.9899 28.0701 13.6199 27.9301C13.1299 27.7401 12.7899 27.5101 12.4199 27.1501C12.0499 26.7801 11.8299 26.4401 11.6399 25.9501C11.4999 25.5801 11.3299 25.0301 11.2799 24.0101C11.2299 22.9101 11.2199 22.5801 11.2199 19.7901C11.2199 17.0001 11.2299 16.6701 11.2799 15.5701C11.3299 14.5501 11.4999 14.0001 11.6399 13.6301C11.8299 13.1401 12.0599 12.8001 12.4199 12.4301C12.7899 12.0601 13.1299 11.8401 13.6199 11.6501C13.9899 11.5101 14.5399 11.3401 15.5599 11.2901C16.6599 11.2401 16.9899 11.2301 19.7799 11.2301ZM19.7799 9.3501C16.9499 9.3501 16.5899 9.3601 15.4799 9.4101C14.3699 9.4601 13.6099 9.6401 12.9499 9.9001C12.2599 10.1701 11.6799 10.5201 11.0999 11.1001C10.5199 11.6801 10.1599 12.2601 9.89986 12.9501C9.63986 13.6101 9.46986 14.3701 9.41986 15.4801C9.36986 16.5901 9.35986 16.9501 9.35986 19.7801C9.35986 22.6101 9.36986 22.9701 9.41986 24.0801C9.46986 25.1901 9.64986 25.9501 9.89986 26.6101C10.1699 27.3001 10.5199 27.8801 11.0999 28.4601C11.6799 29.0401 12.2599 29.4001 12.9499 29.6601C13.6099 29.9201 14.3699 30.0901 15.4799 30.1501C16.5899 30.2001 16.9499 30.2101 19.7799 30.2101C22.6099 30.2101 22.9699 30.2001 24.0799 30.1501C25.1899 30.1001 25.9499 29.9201 26.6099 29.6601C27.2999 29.3901 27.8799 29.0401 28.4599 28.4601C29.0399 27.8801 29.3999 27.3001 29.6599 26.6101C29.9199 25.9501 30.0899 25.1901 30.1499 24.0801C30.1999 22.9701 30.2099 22.6101 30.2099 19.7801C30.2099 16.9501 30.1999 16.5901 30.1499 15.4801C30.0999 14.3701 29.9199 13.6101 29.6599 12.9501C29.3899 12.2601 29.0399 11.6801 28.4599 11.1001C27.8799 10.5201 27.2999 10.1601 26.6099 9.9001C25.9499 9.6401 25.1899 9.4701 24.0799 9.4101C22.9699 9.3601 22.6099 9.3501 19.7799 9.3501Z"
                fill="#7D819A"
              />
              <path
                d="M19.7799 14.4199C16.8199 14.4199 14.4199 16.8199 14.4199 19.7799C14.4199 22.7399 16.8199 25.1399 19.7799 25.1399C22.7399 25.1399 25.1399 22.7399 25.1399 19.7799C25.1399 16.8199 22.7399 14.4199 19.7799 14.4199ZM19.7799 23.2599C17.8599 23.2599 16.2999 21.6999 16.2999 19.7799C16.2999 17.8599 17.8599 16.2999 19.7799 16.2999C21.6999 16.2999 23.2599 17.8599 23.2599 19.7799C23.2599 21.6999 21.6999 23.2599 19.7799 23.2599Z"
                fill="#7D819A"
              />
              <path
                d="M26.6001 14.21C26.6001 14.9 26.0401 15.46 25.3501 15.46C24.6601 15.46 24.1001 14.9 24.1001 14.21C24.1001 13.52 24.6601 12.96 25.3501 12.96C26.0401 12.96 26.6001 13.52 26.6001 14.21Z"
                fill="#7D819A"
              />
            </g>
            <defs>
              <clipPath id="clip0_3660_24436">
                <rect width="39.56" height="39.56" fill="white" />
              </clipPath>
            </defs>
          </svg>

          <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_3660_24429)">
              <path
                d="M38.81 19.78C38.81 9.27002 30.29 0.75 19.78 0.75C9.27002 0.75 0.75 9.27002 0.75 19.78C0.75 30.29 9.27002 38.81 19.78 38.81C30.29 38.81 38.81 30.29 38.81 19.78Z"
                stroke="#7D819A"
                strokeWidth="1.5"
                strokeMiterlimit="10"
              />
              <path
                d="M15.0899 15.54H11.1499V28.26H15.0899V15.54Z"
                fill="#7D819A"
              />
              <path
                d="M13.1 13.8699C14.39 13.8699 15.43 12.8199 15.43 11.5199C15.43 10.2199 14.39 9.16992 13.1 9.16992C11.81 9.16992 10.77 10.2199 10.77 11.5199C10.77 12.8199 11.81 13.8699 13.1 13.8699Z"
                fill="#7D819A"
              />
              <path
                d="M21.3899 21.5801C21.3899 19.7901 22.2099 18.7301 23.7899 18.7301C25.2399 18.7301 25.9299 19.7501 25.9299 21.5801V28.2601H29.8499V20.2001C29.8499 16.7901 27.9199 15.1401 25.2199 15.1401C22.5199 15.1401 21.3899 17.2401 21.3899 17.2401V15.5301H17.6099V28.2501H21.3899V21.5701V21.5801Z"
                fill="#7D819A"
              />
            </g>
            <defs>
              <clipPath id="clip0_3660_24429">
                <rect width="39.56" height="39.56" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
      </div>
    </div>
  );
}

export default LandingFooter;
